import yoproductsServiceClient from '../../../common/helpers/yoproducts-service-client';

function formatPrice(price, locale, currency) {
  const yoproducts = yoproductsServiceClient.get();

  return yoproducts.actions.formatPrice(price, locale, currency, {
    leadingCurrency: true,
  });
}

export default formatPrice;
